import styled from 'styled-components';

export const CommentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  color: #8898aa;
  border-bottom: 1px solid #e9ecef;
  flex-wrap: wrap;
  row-gap: 10px;

  background-color: ${({ $isUnread }) => ($isUnread ? '#eef2ff' : '#f6f9fc')};
  transition: background-color 0.2s ease-in-out;
`;

export const CommentBody = styled.div`
  padding: 1.25rem;
  white-space: pre-wrap;
  line-height: 1.6;
  color: #525f7f;
`;

export const CommentWrapper = styled.div`
  border: 1px solid #e9ecef;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-size: 14px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;

  font-weight: ${({ $isUnread }) => ($isUnread ? 'bold' : 'normal')};
  border-left: ${({ $isUnread }) =>
    $isUnread ? '4px solid #2643e9' : '1px solid #e9ecef'};
  background-color: ${({ $isUnread }) => ($isUnread ? '#f6f9fc' : '#fff')};

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
`;
